import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"

export const CustomerPurchaseOrderNoProductsBanner: FC = () => (
  <InformationMissingAlert title='No products yet. Select individual products to start filling this customer purchase order.' />
)
